function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M219.46,434.34A186.77,186.77,0,0,1,63,249.9c0-103.13,83.9-187,187-187s187,83.9,187,187A187.09,187.09,0,0,1,280.54,434.34V303h43.82l8.83-53.57H280.54V214.67c0-12.77,5.09-28,29.34-28H333.1V139l-.4-.08a244,244,0,0,0-41.11-4.06c-21.52,0-39.57,6.59-52.19,19-13,12.87-19.94,31.76-19.94,54.63V249.4H170.75V303h48.71Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M250,63.37a186.49,186.49,0,0,1,31,370.38V303.47h43.74l.14-.84,8.67-52.56.19-1.17H281V214.67c0-18.25,9.7-27.5,28.84-27.5H333.6v-48.6l-.81-.16a244.23,244.23,0,0,0-41.2-4.07c-21.66,0-39.83,6.64-52.54,19.18-13.14,13-20.09,32-20.09,55V248.9H170.25v54.57H219V433.76A186.48,186.48,0,0,1,250,63.37m0-1a187.49,187.49,0,0,0-30,372.56V302.47H171.25V249.9H220V208.51c0-47.17,28.88-73.17,71.63-73.17a241.19,241.19,0,0,1,41,4v46.78H309.88c-23.3,0-29.84,13.67-29.84,28.5V249.9H332.6l-8.67,52.57H280V434.93c89.33-14.44,157.49-91.84,157.49-185A187.52,187.52,0,0,0,250,62.37Z"
}));

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.90ea9dd0.svg";
export { ForwardRef as ReactComponent };